import { TableExtractPtBr } from "./table-extract-pt-br";

export const TABLE_EXTRACT_EN_US: TableExtractPtBr = {
	consolidated: {
		title: "Consolidated Period",
		totalTitle: "Total of period of {{period}}",
		tooltip: "What is the consolidated period?",
		tooltipDescription:
			"Operations grouped by the date when the operation or economic event actually occurred.",
	},
	cashFlow: {
		title: "Transactions of the period",
		totalTitle: "Final Settled Balance of the period",
		tooltip: "What is the transaction summary?",
		tooltipDescription: "Transaction operations performed during the selected period.",
	},
	tpv: {
		title: "Receivables of the Period",
		totalTitle: "Period Total",
		tooltip: "What are Receivables of the Period?",
		tooltipDescription:
			"Gross value of grouped TPVs for the queried period, representing values to be received from processed transactions.",
	},
	total: "Total",
	name: "Description",
	value: "Value",
	grossValue: "Gross Value",
	netValue: "Net Value",
	tax: "Tax",
	base: "Base",
	feePercentage: "Fee",
	from: "From",
	to: "to",
	group: "Group",
	excel: {
		title:
			"Consolidated Report by Transaction Period and Accrual Consolidation {{startDate}} to {{endDate}}",
		fileName: "consolidated_report_transactions_{{startDate}}_to_{{endDate}}.xlsx",
	},
	withdrawalsPeriod: "Transactions of the period",
	competenceConsolidated: "Accrual Consolidation",
	notLiquidatedTransactions: "Unsettled transactions of the period",
	anticipatedValue: "Anticipated Value",
	obs: "Observation",
	seeTransactions: "View Transactions",
	dateType: {
		competence: "Competence Date",
		liquidation: "Liquidation Date",
	},
	dateTypeLabel: "Filter by",
	competence: "Competence",
	liquidation: "Liquidation",
	apply: "Apply",
	totalEntries: "Total Entries",
	totalExits: "Total Exits",
};
